
define('app/dashboard/account/views/accountView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'app/dashboard/account/views/accountPassView',
	'app/dashboard/account/views/accountDispNameView'
], function($, _, Backbone, UserModel, AccountPassView, AccountDispNameView){
	var AccountView = Backbone.View.extend({
		el: $("#accountInfoContainer"),
		
		initialize: function(options) {
			this.listenTo(this.model, 'change', this.render);
			
			var changePassView = new AccountPassView({model: this.model});
			var changeDispNameView = new AccountDispNameView({model: this.model});
			
			changePassView.render();
			changeDispNameView.render();
		},
		
		render: function () {
			$(this.el).find('#accountUserName').html(this.model.get("userName").toLowerCase());
			$(this.el).find('#accountEmail').html(this.model.get("email"));
			$(this.el).find('#accountDispName').html(this.model.get("displayName"));
			
			if(this.model.get("activated")){
				$(this.el).find('#accountActivated').show();
				$(this.el).find('#accountNotActivated').hide();
				$(this.el).find('#verifyOpen').hide();
			} else {
				$(this.el).find('#accountActivated').hide();
				$(this.el).find('#accountNotActivated').show();
				$(this.el).find('#verifyOpen').show();
			}
			
			return this;
		}
	});
	
	return AccountView;  
});